/* Odds Comfort: cart engine. Add / change / remove via the Ajax Cart API, server-rendered drawer and cart page through the
   Section Rendering API, smart upsells (cart drawer, cart page), the "complete your set" popup and the exit reminder. */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;
  var R = Odds.cfg.routes || {};
  var F = Odds.cfg.features || {};

  var Cart = (Odds.cart = {
    state: { count: Number((Odds.cfg.cart || {}).count) || 0, total: Number((Odds.cfg.cart || {}).total) || 0, handles: (Odds.cfg.cart || {}).handles || [], codes: [] },
    busy: false,

    sectionIds: function () {
      /* sections that live in a section group get a generated id (sections--123__cart-drawer), so read the real one from the page */
      var dr = document.getElementById('cart-drawer'), wrap = dr && dr.closest('.shopify-section');
      var ids = [wrap && wrap.id ? wrap.id.replace(/^shopify-section-/, '') : 'cart-drawer'];
      $$('[data-cart-section]').forEach(function (el) { var id = el.getAttribute('data-cart-section'); if (id && ids.indexOf(id) < 0) ids.push(id); });
      return ids.join(',');
    },

    drawer: function () { return $('#cart-drawer'); },
    open: function () { var d = Cart.drawer(); if (d) { Odds.overlay.open(d, { focus: '[data-overlay-close]' }); Cart.upsells(); } },
    close: function () { var d = Cart.drawer(); if (d) Odds.overlay.close(d); },

    /* swap server-rendered parts of the sections we asked for */
    applySections: function (sections) {
      Cart.gotMeta = false;
      if (!sections) { Cart.syncFromJson(); return; }
      Object.keys(sections).forEach(function (id) {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var live = document.getElementById('shopify-section-' + id);
        if (!live) return;
        ['[data-cart-body]', '[data-cart-foot]', '[data-cart-head]', '[data-cart-main]', '[data-cart-summary]'].forEach(function (sel) {
          var n = $(sel, doc), o = $(sel, live);
          if (n && o) o.innerHTML = n.innerHTML;
        });
        var meta = $('[data-cart-meta]', doc);
        if (meta) {
          Cart.gotMeta = true;
          Cart.state.count = Number(meta.getAttribute('data-count')) || 0;
          Cart.state.total = Number(meta.getAttribute('data-total')) || 0;
          try { Cart.state.handles = JSON.parse(meta.getAttribute('data-handles') || '[]'); } catch (e) { Cart.state.handles = []; }
          try { Cart.state.codes = JSON.parse(meta.getAttribute('data-codes') || '[]'); } catch (e) { Cart.state.codes = []; }
        }
      });
      if (!Cart.gotMeta) { Cart.syncFromJson(); return; }
      Cart.paintCount();
      Odds.emit('dom:updated');
      Odds.emit('cart:change', Cart.state);
    },
    /* fallback when the server did not hand back the drawer markup: read the cart as JSON and rebuild the drawer from it */
    syncFromJson: function () {
      return Odds.fetchJSON(R.cart_base + '.js').then(function (c) {
        Cart.state.count = c.item_count || 0;
        Cart.state.total = c.total_price || 0;
        Cart.state.handles = (c.items || []).map(function (i) { return i.handle; });
        Cart.paintCount();
        Odds.emit('cart:change', Cart.state);
        return Odds.fetchJSON(Odds.url('/?sections=' + encodeURIComponent(Cart.sectionIds()))).then(function (secs) {
          Object.keys(secs || {}).forEach(function (id) {
            var doc = new DOMParser().parseFromString(secs[id], 'text/html');
            var live = document.getElementById('shopify-section-' + id);
            if (!live) return;
            ['[data-cart-body]', '[data-cart-foot]', '[data-cart-head]', '[data-cart-main]', '[data-cart-summary]'].forEach(function (sel) {
              var n = doc.querySelector(sel), o = live.querySelector(sel);
              if (n && o) o.innerHTML = n.innerHTML;
            });
          });
          Odds.emit('dom:updated');
        }).catch(function () {});
      }).catch(function () {});
    },
    paintCount: function () {
      $$('[data-cart-count]').forEach(function (el) { Odds.bump(el, Cart.state.count); });
    },

    /* generic POST to the cart endpoints, asking for fresh sections back */
    post: function (endpoint, body) {
      body = Object.assign({}, body, { sections: Cart.sectionIds(), sections_url: location.pathname });
      return Odds.fetchJSON(R.cart_base + endpoint + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) { Cart.applySections(res.sections); return res; });
    },

    add: function (items, opts) {
      opts = opts || {};
      if (Cart.busy) return Promise.resolve(null);
      Cart.busy = true;
      return Cart.post('/add', { items: items })
        .then(function (res) {
          Cart.busy = false;
          var handles = (res.items || []).map(function (i) { return i.handle; });
          if (Odds.brain) handles.forEach(function (h) { Odds.brain.track('add', { h: h }); });
          Odds.emit('cart:added', { items: res.items || [], opts: opts });
          if (opts.popup && F.upsellPopup && (res.items || []).length) Cart.popup((res.items || [])[0]);
          else if (opts.open !== false) Cart.open();
          return res;
        })
        .catch(function (err) {
          Cart.busy = false;
          var msg = err && err.body && (err.body.description || err.body.message);
          Odds.toast(msg || Odds.t('cart_error'));
          Odds.emit('cart:error', err);
          throw err;
        });
    },

    change: function (line, qty) {
      if (Cart.busy) return Promise.resolve(null);
      Cart.busy = true;
      return Cart.post('/change', { line: line, quantity: qty })
        .then(function (r) { Cart.busy = false; return r; })
        .catch(function (err) { Cart.busy = false; Odds.toast(Odds.t('cart_error')); throw err; });
    },

    setNote: function (note) { return Odds.fetchJSON(R.cart_base + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note }) }); },

    refresh: function () {
      return Odds.fetchJSON(Odds.url('/?sections=' + encodeURIComponent(Cart.sectionIds())))
        .then(function (sections) { Cart.applySections(sections); });
    },

    /* ---- smart upsells ---- */
    upsells: function () {
      if (!F.upsellCart) return;
      var hosts = $$('[data-cart-upsell]');
      if (!hosts.length || !Cart.state.count) { hosts.forEach(function (h) { h.innerHTML = ''; }); return; }
      Odds.catalog.load().then(function () {
        var threshold = Number(Odds.cfg.freeShipping) || 0;
        var gap = threshold ? Math.max(0, threshold - Cart.state.total) : 0;
        var rec = Odds.brain.recommend({ context: 'cart', cartHandles: Cart.state.handles, gap: gap, n: 3 });
        var recAll = rec.items;
        hosts.forEach(function (h) {
          rec.items = h.closest('#cart-drawer') ? recAll.slice(0, 2) : recAll;
          if (!rec.items.length) { h.innerHTML = ''; return; }
          var title = gap > 0 ? Odds.t('cart_upsell_free', { amount: Odds.money(gap, true) }) : Odds.t('cart_upsell');
          h.innerHTML = '<div class="upsell"><div class="upsell-head"><svg class="icon" aria-hidden="true"><use href="#i-spark"/></svg><b>' + Odds.esc(title) + '</b></div><div class="upsell-row">' +
            rec.items.map(function (p) { return Odds.render.upsellCard(p); }).join('') + '</div></div>';
        });
        Odds.emit('dom:updated');
      });
    },

    /* ---- "complete your set" popup after add from product page / quick view ---- */
    popup: function (item) {
      var m = $('#upsell-popup'); if (!m) { Cart.open(); return; }
      Odds.catalog.load().then(function () {
        var rec = Odds.brain.recommend({ context: 'popup', product: item.handle, cartHandles: Cart.state.handles, n: 3, curated: (Odds.catalog.byHandle[item.handle] || {}).pw || [] });
        var threshold = Number(Odds.cfg.freeShipping) || 0;
        var gap = threshold ? Math.max(0, threshold - Cart.state.total) : 0;
        var bar = threshold ? '<div class="ship"><span>' + (gap ? Odds.t('cart_free_away', { amount: Odds.money(gap, true) }) : Odds.t('cart_free_unlocked')) + '</span><div class="track"><i style="width:' + Math.min(100, Cart.state.total / threshold * 100) + '%"></i></div></div>' : '';
        var img = item.featured_image && item.featured_image.url ? '<img src="' + Odds.esc(Odds.img(item.featured_image.url, 200)) + '" alt="">' : '';
        $('[data-popup-body]', m).innerHTML =
          '<div class="pop-added"><span class="ph">' + img + '</span><div><span class="eyebrow" style="color:var(--ok)">✓ ' + Odds.t('popup_title') + '</span><b>' + Odds.esc(item.product_title) + '</b><small>' + Odds.esc(item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</small></div></div>' + bar +
          (rec.items.length ? '<div class="pop-rec"><div class="upsell-head"><svg class="icon" aria-hidden="true"><use href="#i-spark"/></svg><b>' + Odds.t('popup_subtitle') + '</b></div><div class="upsell-row">' + rec.items.map(function (p) { return Odds.render.upsellCard(p); }).join('') + '</div></div>' : '') +
          '<div class="pop-actions"><button class="btn ghost" type="button" data-overlay-close>' + Odds.t('popup_keep') + '</button><a class="btn red" href="' + R.cart + '">' + Odds.t('popup_view') + '</a><a class="btn" href="' + R.checkout + '">' + Odds.t('popup_checkout') + '</a></div>';
        Odds.overlay.open(m, { focus: '[data-popup-body] .btn.red' });
        Odds.emit('dom:updated');
      });
    }
  });

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest && t.closest('[data-cart-open]');
    if (op) { e.preventDefault(); Cart.open(); return; }

    var rm = t.closest && t.closest('[data-cart-remove]');
    var qb = t.closest && t.closest('[data-cart-qty]');
    if (rm || qb) {
      var row = (rm || qb).closest('[data-line]'); if (!row) return;
      e.preventDefault();
      var line = Number(row.getAttribute('data-line')), q = Number(row.getAttribute('data-qty'));
      var vid = Number(row.getAttribute('data-variant')), props = null;
      try { props = JSON.parse(row.getAttribute('data-properties') || 'null'); } catch (er) { props = null; }
      var next = rm ? 0 : q + Number(qb.getAttribute('data-cart-qty'));
      if (next < 0) next = 0;
      row.classList.add('is-updating');
      Cart.change(line, next).then(function () {
        if (rm || next === 0) Odds.toast(Odds.t('cart_removed'), Odds.t('undo'), function () { Cart.add([{ id: vid, quantity: q, properties: props || undefined }], { open: false }).then(function () { Cart.upsells(); }); });
        Cart.upsells();
      });
      return;
    }

    var up = t.closest && t.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      var vId = Number(up.getAttribute('data-upsell-add'));
      up.classList.add('is-loading');
      var inPopup = up.closest('#upsell-popup');
      Cart.add([{ id: vId, quantity: 1 }], { open: !inPopup }).then(function () {
        up.classList.remove('is-loading'); up.classList.add('added'); up.textContent = '✓';
        if (inPopup) Odds.toast(Odds.t('cart_added'));
        Cart.upsells();
      }).catch(function () { up.classList.remove('is-loading'); });
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-discount-form]');
    if (!f) return;
    e.preventDefault();
    var input = $('input', f), code = (input.value || '').trim(); if (!code) return;
    var msg = $('[data-discount-msg]', f.parentNode);
    var btn = $('button[type=submit]', f); btn.classList.add('is-loading');
    fetch(Odds.url('/discount/' + encodeURIComponent(code)), { credentials: 'same-origin' }).then(function () { return Cart.refresh(); }).then(function () {
      btn.classList.remove('is-loading');
      var ok = (Cart.state.codes || []).some(function (c) { return String(c).toLowerCase() === code.toLowerCase(); });
      var m2 = $('[data-discount-msg]', Cart.drawer() || document) || msg;
      if (m2) { m2.textContent = ok ? Odds.t('cart_discount_applied', { code: code }) : Odds.t('cart_discount_invalid'); m2.className = 'form-msg ' + (ok ? 'ok' : 'err'); m2.hidden = false; }
    }).catch(function () { btn.classList.remove('is-loading'); });
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cart-note]')) {
      clearTimeout(noteTimer);
      var v = e.target.value; noteTimer = setTimeout(function () { Cart.setNote(v); }, 600);
    }
  });

  Odds.on('cart:change', function () { Cart.upsells(); });
  document.addEventListener('DOMContentLoaded', function () { Cart.paintCount(); Cart.upsells(); });
  Cart.paintCount();

  /* ---- exit-intent reminder (desktop, once per session, only with items in the bag) ---- */
  if (F.upsellExit && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var armed = false;
    setTimeout(function () { armed = true; }, 8000);
    document.addEventListener('mouseout', function (e) {
      if (!armed || e.clientY > 0 || e.relatedTarget) return;
      if (!Cart.state.count || sessionStorage.getItem('odds:exit') || /\/cart|\/checkouts?\//.test(location.pathname)) return;
      if (Odds.overlay.top()) return;
      var m = $('#exit-popup'); if (!m) return;
      try { sessionStorage.setItem('odds:exit', '1'); } catch (err) { /* ignore */ }
      $('[data-exit-text]', m).textContent = Odds.t('exit_text', { count: Cart.state.count });
      Odds.overlay.open(m, { focus: '[data-exit-go]' });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-exit-go]')) { var m = $('#exit-popup'); Odds.overlay.close(m, true); Cart.open(); }
    });
  }
})();
